__webpack_require__.p = "/wp-content/themes/beaimmo-landing-2024/assets/";